import { useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import type { GalleryBlockType } from "@features/article-content/model";

import { Image } from "@shared/ui/image";
import { SwiperNavButtons } from "@shared/ui/slider-nav-buttons";
import { Body } from "@shared/ui/typography";

import s from "./gallery.module.scss";

export const Gallery = (props: GalleryBlockType) => {
  const { images } = props;

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={s.root}>
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        className={s.slider}
        loop
        pagination={{
          el: `.${s.pagination}`,
          type: "bullets",
          clickable: true,
          bulletClass: `${s.bullet}`,
          bulletActiveClass: `${s.bulletActive}`,
        }}
        onSlideChange={({ realIndex }) => setActiveIndex(realIndex)}
      >
        {images?.map((slide, idx) =>
          slide?.url ? (
            <SwiperSlide
              key={`slide-${slide?.documentId ?? idx}`}
              className={s.slide}
            >
              <Image
                src={slide.url}
                alt={slide?.alternativeText ?? "slide image"}
                className={s.slideImage}
              />
            </SwiperSlide>
          ) : null,
        )}
        {images.length > 1 && (
          <>
            <div className={s.bottom}>
              <Body size="caption">
                <span>{images[activeIndex]?.caption}</span>
              </Body>
              <SwiperNavButtons
                variant="dark"
                className={s.navigation}
                totalSlides={images?.length}
                currentIndex={activeIndex}
              />
            </div>
            <div className={s.pagination}></div>
          </>
        )}
      </Swiper>
    </div>
  );
};

Gallery.displayName = "Gallery";
